import React from "react";
import styled from "styled-components";
import { FormSelect } from "../../../components/Forms/FormSelect";
import { SmartContainer } from "../../../styles/Containers";
const StyledLimitSelect = styled(SmartContainer)`
    max-width: 75px;
`
export const Limit = ({ value, onChange }) => {
    return (
        <StyledLimitSelect data-limit-select>
            <FormSelect value={value} onChange={onChange}>
                <option value={20}>20</option>
                <option value={40}>40</option>
                <option value={60}>60</option>
                <option value={80}>80</option>
                <option value={100}>100</option>
            </FormSelect>
        </StyledLimitSelect>
    )
}